// A rough landed cost for one car: the typical ranges the individual setup guide's Budget step
// shows, and the Import my own page's illustration. Typical ranges, not quotes — both say so.
// The car pass price comes from the live pricing. Lives in lib/ with no app imports: it is part
// of the marketing bundle too — so it never carries a broker's agreed fee. The signed-in app
// passes the shop's own broker fee in (`broker`); the public page shows only the generic note.
/** Import duty as a share of the auction price: a range, since US tariffs on Japanese vehicles
 * keep changing and depend on how the broker classifies the vehicle. */ export const DUTY_LOW = 0.125;
export const DUTY_HIGH = 0.25;
/** The broker line's note on a public page: no broker's fee, which brokers quote privately. */ export const BROKER_NOTE_PUBLIC = 'a licensed broker’s fee per car — your broker quotes it';
/** The lines from hammer to driveway, in dollars. */ export function roughLanded({ hammerUsd, passCents, broker }) {
    const fee = broker && broker.feeUsd > 0 ? broker : undefined;
    const h = Math.max(0, hammerUsd);
    const lines = [
        {
            label: 'The car at auction',
            low: h,
            high: h
        },
        {
            label: 'Auction and agent fees',
            low: 500,
            high: 900,
            note: 'the auction house’s fee and your agent’s'
        },
        {
            label: 'Ocean freight to a US port',
            low: 1500,
            high: 2200
        },
        {
            label: 'Import duty — recently 12.5–25%',
            low: h * DUTY_LOW,
            high: h * DUTY_HIGH,
            note: 'tariffs change often; your broker confirms the rate for your car'
        },
        {
            label: 'Customs broker, bond and port fees',
            low: Math.max(450, fee?.feeUsd ?? 0),
            high: Math.max(900, fee?.feeUsd ?? 0),
            note: fee ? `${fee.name} charges ${usd(fee.feeUsd)} a car` : BROKER_NOTE_PUBLIC
        },
        {
            label: 'Trucking from the port',
            low: 300,
            high: 1200,
            note: 'depends on the distance'
        },
        {
            label: 'Right Hand DMS car pass',
            low: passCents / 100,
            high: passCents / 100,
            note: 'per car you win — signing up covers your first'
        }
    ];
    return {
        lines,
        low: lines.reduce((s, l)=>s + l.low, 0),
        high: lines.reduce((s, l)=>s + l.high, 0)
    };
}
/**
 * The same lines across a spread of auction prices: each line's low from the cheapest car and
 * its high from the dearest, so the illustration shows how widely JDM cars vary.
 */ export function roughLandedRange({ hammerLow, hammerHigh, passCents, broker }) {
    const lo = roughLanded({
        hammerUsd: hammerLow,
        passCents,
        broker
    });
    const hi = roughLanded({
        hammerUsd: hammerHigh,
        passCents,
        broker
    });
    const lines = lo.lines.map((l, i)=>({
            ...l,
            high: hi.lines[i].high
        }));
    return {
        lines,
        low: lo.low,
        high: hi.high
    };
}
/** "$4,000" — whole dollars. */ export const usd = (n)=>`$${Math.round(n).toLocaleString('en-US')}`;
/** "$500–$900", or one figure when low and high agree. */ export const usdRange = (lo, hi)=>Math.round(lo) === Math.round(hi) ? usd(lo) : `${usd(lo)}–${usd(hi)}`;
